// extracted by mini-css-extract-plugin
export default {"wrapper":"Textarea_wrapper__YwBKD","textarea":"Textarea_textarea__yge9M"};